module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Melanie Andrews waited for the driver to repeat the address in heavily accented English before she settled back against the seat of the smelly cab with a hard shiver. The vehicle would have been plenty warm if she’d been wearing a coat, or even decent clothing, but she wasn’t. She thought longingly of her warm cloth coat, still inside the luxury suite on the top floor of the hotel. The coat was old, but still serviceable. Too bad she’d never see it again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She met the driver’s expression in the rearview mirror. He smiled broadly and winked. She narrowed her eyes and gave him a hostile glare. If he had any perverted ideas about taking her someplace besides the address she’d just given him, he’d find out exactly how valuable these stiletto heels could be. He needed to pay closer attention to the worsening road conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No doubt he thought she was a hooker. That’s probably what her rescuer had thought, too. This dress was enough to give anyone that impression. It was exactly the impression she’d been trying to create.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Mel sighed. She looked down at the objects in her hand and a jolt of panic tingled down her spine. She’d shoved the dead man’s keys and plastic card in the deep pocket of ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("the fur coat, but she’d only been able to palm the card before she dropped the fur because she’d also had her rescuer’s wallet and keys in her hand. She was going to need those keys.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared at the garish club card and tried to fight the panic clawing at her. She’d taken the wrong bit of plastic. This was not the key card she’d removed from the dead man’s wallet. The card to get into his office building must be still inside the fur coat. Her prints were all over that bit of plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel forced her breathing to steady. Panic was the fast road to disaster. Her prints weren’t on file anywhere and the model wouldn’t know what the card was or where it had come from when she did discover the thing. She’d probably toss it out without a second thought. Besides, there was nothing Mel could do about the situation at the moment. She didn’t even have a last name for the woman her rescuer had called Shereen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ignoring the driver’s covert glances at the front of her dress, Mel opened the well-tooled leather wallet she’d palmed. Her fingers shook, and not from the cold. She hated that she’d repaid his kindness by lifting his wallet, but she’d needed to pay for the cab ride somehow. It was galling to realize that she hadn’t planned as well as she should have. She should have pinned money inside her dress, or at least grabbed her purse when she fled. Not that there had been time for that. Getting away had been far more important than searching for her purse on the bed filled with coats and a dead man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel knew her thoughts were darting about in a ridiculous manner, but thinking of other things was better than thinking about that horrible dead body and the fact that the D.C. police would soon be scouring the city for her.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head and stared at the driver’s license in her hands. Roderick Anthony Laughlin III. There was a mouthful, yet somehow the stuffy name suited him, even if it was at odds with that kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She touched a finger lightly to her lips, remembering the hot press of his mouth and the answering heat that had stirred within her. The man had almost swept her off her spiked heels. For a split second Mel had lost track of everything. That had never happened to her before. It unsettled her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who was Roderick Laughlin?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The picture on his driver’s license didn’t do him justice. His wasn’t a handsome face. The shape was too angular, the features too boldly intense. Yet even in the picture, the sense of controlled power and self-assurance came through. From the balcony, she’d singled him out as much for his height as for his apparent destination. Yet according to his driver’s license, Roderick Laughlin was only six feet tall. He’d seemed taller. Larger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Safe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How crazy was that? Claire was right. She needed to get out more. Meeting interesting men was not easy when one was stuck in a kitchen day after day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, it would be even harder to do from inside a jail cell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel sighed. Roderick Laughlin’s leanness had been deceptive. There had been undeniable strength in the rippled muscles she’d felt beneath that perfectly fitted tuxedo jacket. Why was it men always looked so appealing in a tuxedo?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Mel shook aside that thought. Her slight frame tended to give some men the mistaken belief she needed to be shielded and protected. She was willing to use that impression when it suited her purposes, like tonight, but mostly ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("coddling annoyed her. Roderick Laughlin hadn’t annoyed her. Instead he’d made her sharply aware of her femininity.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That had been some kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel yanked her thoughts from that path, too, and flipped to the compartment holding his money. The unanticipated wad of bills made her bite her lower lip to stifle a gasp of dismay. Didn’t the man believe in banks and credit cards?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wryly, she wondered what she had expected. A bash like the one at that fancy hotel catered only to the rich and famous. Apparently, Roderick Laughlin was rich. How unfortunate that he chose to carry around enough cash to send her to jail for grand theft if she was caught.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nearly laughed out loud. Grand theft was the least of her worries. The police would be far more interested in tagging her for murder than a simple lift.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Blast!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You say something lady?” the driver asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His stare was just this side of a leer as they stopped for a traffic light. Mel met his gaze coldly in the rearview mirror until he lowered his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good. She did not need another problem tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The evening had not gone well. At first she’d stayed close to the group she’d come in with. Then she’d spotted Harold DiAngelis across the room. She was sure she’d seen a flash of startled recognition in his eyes before she’d moved away in search of her quarry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except he shouldn’t have known who she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("DiAngelis worked with Gary, but her brother didn’t like the older man. The two had never socialized. Heck, they barely spoke, from what she gathered. There was no way Gary would have mentioned her to DiAngelis.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There hadn’t been time to wonder about that then, but she was fretting over it now. DiAngelis was bound to identify her to the police. His presence at the hotel at that particular party couldn’t be coincidence. Was DiAngelis somehow involved in the theft of her brother’s program? Maybe he was even the person who had killed Carl Boswell and taken the DVD!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The taxi slid on the slick pavement as they rounded a corner. The driver swore fluently. He barely avoided a collision with a stretch of parked cars. He offered her a wink and a wide grin as he straightened out and double-parked in front of a tired-looking redbrick building.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel handed him the money she’d pulled from the wallet in anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Want company?” the driver asked, his leer firmly in place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel inclined her head toward the lighted window of the apartment three stories up. Even from inside the cab the sounds of a party in full swing were unmistakable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve already got plenty of company,” she said as she handed him the money.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man nodded acceptance, but he waited, watching her climb the stone steps to the entrance before he roared off to disappear into the swirling snowflakes. As soon as the cab was out of sight, Mel went back down and hurried along the sidewalk as fast as her borrowed too-high heels would allow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Snow peppered her skin. In minutes she was liberally coated from her hair to the pinching points of her shoes where her frozen toes begged for mercy. She was so cold she wasn’t sure how she made it to the Metro parking lot where she’d left her car earlier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("The police would trace the cab, of course, but the build")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("ing would bring them to a dead end. Now, if only she could get her reluctant engine to start! Her twelve-year-old car did not like the cold any more than she did, and the transmission was going.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Curbing her frantic need to get away from the area, Mel finally coaxed the engine to life while shivers wracked her. Nothing resembling heat came from the vents even after she pulled out of the subway parking lot. The streets were growing more treacherous by the minute. Mel didn’t have to turn on the radio to know a snow emergency ban would be in effect. That meant she’d have to find a parking place near her apartment building on one of the side streets that wasn’t deemed an emergency route. Too bad she couldn’t afford the monthly fee to park in the parking garage a block over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time she reached the foyer of her apartment building, two horrifically long blocks from where she’d had to park, the new year was several minutes old and she could no longer feel the finger that pressed Claire Bradshaw’s apartment buzzer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes?” the tinny voice questioned over the speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Claire, it’s Mel. Let me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The buzzer answered her plea. Teeth chattering uncontrollably, she grasped the door handle and pushed eagerly into the warmth of the foyer. Her skin burned with returning circulation as she climbed the three flights and tried to ignore the icy rivulets of water melting against her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good Lord’a’mighty have mercy,” Claire exclaimed as Mel reached her floor, huffing between fierce shivers. “What on earth were you doing running around outside dressed like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tempting frostbite,” she managed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire tsk-tsked as she ushered Mel inside. “Where’s your coat? Never mind. Get inside before you drop.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her elderly neighbor ushered her into a cozy warm room. Mel heard her suck in another gasp as she got a good view of Mel’s backside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good Lord,” Claire whispered. “Didn’t I tell you that dress was overkill?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another time, Mel might have laughed. Claire had told her as much, even though she’d only seen the dress on the hanger until now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t have a lot of choice. Sue has flamboyant taste.” A serious understatement. Sue had been Mel’s next-door neighbor when she first moved to D.C. Outgoing and courageous, the pretty redhead had made it impossible for Mel not to be friends with her despite how little they had in common. But her friend was exactly her size right down to the shoe size. There hadn’t been time to go shopping for something more suitable after Gary called so she’d stopped at her friend’s apartment to borrow an outfit for the party.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, Claire hadn’t lived some seventy-odd years without learning when to give in to shock and when to get on with what needed doing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Into the shower,” she ordered. “You’ll have pneumonia if we don’t get you warmed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire Bradshaw scowled. Without bothering to argue she went to the closet and plucked out a heavy cardigan sweater and helped Mel into the thick wool. Forcing her down into the nearest chair, her friend quickly wrapped the afghan from the couch around her legs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lethargy pulled at her. Mel shut her eyes and allowed herself a minute to huddle in the chair, absorbing warmth into her chilled, damp body. When Claire set a steaming cup of hot chocolate on the end table at her elbow, Mel forced her eyes open again.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Drink every drop,” Claire ordered. “Hot chocolate warms a body faster than anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel tried to pick up the mug, but her hands shook too much to hold the heavy stoneware. Claire’s wrinkled face added new creases as she lifted the mug so Mel could take a sip. The liquid was hot but not scalding, and Mel drank greedily. The next time she told her hands to reach for the cup, they closed around the blessed warmth and she shuddered gratefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A moment later Claire produced a fluffy warm towel. She must have taken it from the small clothes dryer in her kitchen because the terry cloth was soothingly warm and smelled of fabric softener.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Use this on your hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel sank her hands into the thick towel with a sigh of pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have much time,” she told her friend as she toweled her sodden hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The police?” Claire asked quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel grimaced. “I’m afraid so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you get the disk?” Claire asked with a nod at the wallet and key case Mel had dropped on the end table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel shook her head, feeling the bitter weight of defeat. “It’s a DVD, not a disk, and no. Someone beat me to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, dear. What can I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need the spare key to get inside my apartment. My key is in my coat pocket and I had to leave it behind. I have to disappear for a few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The wallet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Used to her friend’s verbal shorthand, Mel had no trouble understanding that question. “That isn’t the reason. The wallet didn’t come from that party.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You went to another party?”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not by choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She picked up the supple leather, allowing her fingertips to stroke the soft, expensive-looking material. Claire raised questioning eyebrows and Mel lifted her shoulders trying not to think about the handsome stranger who had helped her escape.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Carl Boswell was murdered before I got there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, my.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It gets worse. The program was gone and someone Gary works with was at the party. Harold DiAngelis. I’m pretty sure he recognized me. I caught him staring at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire snorted and looked meaningfully down at her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel managed a weak smile. “I wish it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been the dress, but I’m not even sure he noticed what I was wearing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire raised expressive eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really. It’s no coincidence he was there, Claire. I’m betting he killed Boswell and took the program.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Large assumption.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe, but you know how Gary feels about DiAngelis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How would he know about Gary’s program?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did he know who I am?” Reluctantly, she pushed aside the blanket and unwound the towel from her head. “I’d better go. DiAngelis is sure to put the police on to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s your purse?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I dropped it on the bed when I searched Boswell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You searched him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel shivered at the memory. At the time, she hadn’t let herself think about what she was doing. She didn’t want to think about it now, either.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s your coat?”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had to leave it and Sue’s purse behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mel!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t carrying ID, not that it matters now. But I do owe Sue a new purse. I need to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’d be safe here,” Claire protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think so. If DiAngelis recognized me, there’s no telling what he knows about the people connected to Gary. He may know about you, as well. Pull the shades, turn out the lights, and don’t answer the door or the phone, whatever you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel rose to her feet, feeling woozy and more tired than she would have liked. She was still chilled and damp but her instincts were screaming at her to get moving. Claire bustled back to the kitchen and returned with Mel’s spare key.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where will you go?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once again, Mel rubbed the supple leather of the wallet. “I have a bolt-hole in mind. Don’t worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At my age, worrying is an art form.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel smiled and started to remove the sweater. The older woman shook her gray curls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Later. Do what you have to, Mel. I’m here if I can help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You already have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel hugged her friend. For just a second, she let herself inhale the older woman’s familiar powdery scent. Claire had once been her grandmother’s best friend. Now she was Mel’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know what I’d do without you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire issued another ladylike snort. “You’d manage. You’re like your parents.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not Grandma?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire smiled. “She’d be proud of you.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not after tonight’s debacle,” Mel said ruefully, “but thanks again, Claire. Oh, and happy New Year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stay safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s the plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel was still smiling as she let herself inside the dark apartment across the hall. Without light, she crossed to the bedroom and began collecting what she needed. She pulled a pair of sweatpants from the dresser drawer and tugged them on over the dress. She couldn’t afford to leave the dress behind and she didn’t want to waste time removing it. Moving fast, despite the shivers plaguing her, Mel struggled into a baggy black sweatshirt that barely fit over the cumbersome sweater. The result was restrictive, but seductively warm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She found heavy cotton socks by touch in another drawer before she reached for the shoe tree to feel for her black sneakers. Snatching underwear at random, she fumbled for the old scuffed duffel bag shoved in the back of her closet and stuffed it with the rest of the essential items.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because she’d been listening hard the whole time, the anticipated sound of a car pulling up outside sent her rushing across the room to peer down at the sidewalk. Two men exited a long sedan that had pulled to the curb. They peered up at the building through the hurling snowflakes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel knew they couldn’t see her, but she remained perfectly still anyhow until they looked away and mounted the steps. She was out of time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tossing the tennis shoes on top, she closed the bag, jammed her feet into black steel-toed work boots, grabbed her only other jacket and raced for the door. Claire’s buzzer shrilled. Hers a moment later. No doubt they were buzzing at random in hopes someone would let them inside. Sooner or later someone would.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel took time to lace her boots and relock her front door before sprinting down the hall to the laundry room at the far end. It took muscle, but she finally got the frozen window open. Tossing her coat and the bag to the ground, she climbed onto the narrow snow-covered ledge that circled the third floor. She maneuvered the window down until it snapped closed and wished she’d taken the time to pull the gloves from her coat pocket. Her fingers cooperated despite feeling numb as she worked her way along the ledge to the drainpipe. Testing the give, she found it still anchored securely. Using the pipe she worked her way down the side of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A foot from the bottom, she kicked free and dropped. The wind had picked up, so snow would cover her tracks quickly. She scooped up her belongings and melted into the shadows of the neighboring building.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODERICK WAS NOT")]), _vm._v(" in a good mood when he returned to the main ballroom. Shereen stood near the dance floor in animated conversation with Roderick’s most powerful competitor and that rarest of species—a wealthy, eligible bachelor like himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Roderick!” Shereen greeted him when she spotted him. “Just look at my dress! It’s completely ruined! Some clumsy drunk dumped an entire glass of burgundy all over me! I don’t know what I’m going to do. I tried wiping the stains off in the bathroom, but I’m sure my dry cleaner will never be able to get them out completely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then it’s a good thing I brought your coat,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her perfectly plucked eyebrows arched. “You want to leave? Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It isn’t even midnight yet,” Larry Wilhelm protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wilhelm,” Roderick acknowledged the other man grudgingly.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t mind Roderick, he has a headache,” Shereen said with asperity. “I suggested he go take another aspirin or have another drink, but Roderick isn’t fond of parties, are you darling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he said tersely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Deliberately, Wilhelm ran a knuckle down Shereen’s bare upper arm. “You know what they say about all business and no play, Laughlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shereen offered him a teasing smile. Roderick didn’t bother to conceal his annoyance with the pair. “I prefer to do my playing in private.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wilhelm raised his eyebrows mockingly. “Sorry, Laughlin, I didn’t realize I was treading on private property.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The heck he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am hardly anyone’s property,” Shereen stated archly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking at the haughty arrogance in every line of her elegant body, Roderick realized how little he actually liked the woman underneath those superficial charms. Shereen was decorative and intelligent and extremely talented in the bedroom, but the world was filled with women like her. While they had suited each other for a surprising number of months now, he realized the relationship was no longer worth the effort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had he come to that realization because of Shereen’s apparent interest in Wilhelm, or because of a small, pointy face and two large eyes that had lit with an inner glow whenever that brilliant smile appeared?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was an understatement to say the young woman he’d just helped wasn’t his type. She was short rather than statuesque, and far from model thin. And heaven knew she had no sense of style. Still, she intrigued him, and Roderick had always enjoyed a good puzzle.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was rather rude, darling,” Shereen told him as he led her away. “Larry was simply being nice by keeping me company while I waited for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t have a chance to voice his opinion on that because just then the mayor and his wife flagged them down. Being rude to Wilhelm was one thing, but Roderick genuinely liked the young mayor and the group of people they were with. Shereen drifted away, leaving him sorely tempted to let her find her own way home. Good manners prevailed and they stayed until midnight after all. By the time he got Shereen out of the ballroom and onto the escalator, his headache was creeping close to migraine territory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“…and I don’t know why we couldn’t take the elevator,” Shereen was complaining. “Escalators are so dirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too crowded,” he told her shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This aversion you have for elevators is really quite annoying at times, you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused to regard her before crossing to the next set of moving steps. “If you want to take the elevator, Shereen, feel free,” he told her brusquely and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You really are in a mood, aren’t you?” Shereen said waspishly as she hurried after him. “You’re still miffed because I was talking to Larry earlier. You know, just because you and Larry often find yourselves rivals at times, it wouldn’t have hurt you to make nice. Larry does move in all the right circles, you know. He was just telling me how his company got a juicy new contract working with Homeland Security. Instead of acting so rudely, you’d do well to encourage a relationship with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick didn’t look at her. “I’ll leave that to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She inhaled audibly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t tell me you were jealous, darling,” she purred after a moment.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped off the escalator and moved across the tiled foyer ahead of her to hand the valet his parking ticket. Outside, snow had coated the roads, continuing its downward spiral with growing speed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t realize,” Shereen said in her most conciliatory tone of voice. “You were probably bidding on the same contract.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick didn’t bother to respond. She’d realized. They’d even discussed his plans. When RAL had bid on the contract and lost, he’d simply chalked it up to part of doing business. The loss had nothing to do with his instinctive dislike of the man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shereen fell silent beside him as they waited for the Mercedes to be brought around. Roderick barely noticed her. He was busy planning the phone call he would make first thing tomorrow morning to begin his search for the mystery woman. Anticipation had his thoughts moving briskly as the dark green sedan rolled to a stop. Roderick reached for his billfold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And came up empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is something wrong?” Shereen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My wallet seems to be missing.” He checked the other pocket. Empty, as well. Not just his wallet, his keys were gone, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shereen frowned. “Maybe it fell out in your car,” she suggested. “When did you have it last?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick knew exactly when he’d had it last. He’d tipped the cloakroom attendant and replaced the wallet in his inner pocket. Then the mystery woman in the sparkly green dress had slid her arms around him—beneath the tuxedo jacket.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("He swore out loud. The little witch had lifted his wal")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("let and his keys and he’d never felt a thing. He couldn’t believe he’d been suckered by a pro.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You could have dropped it upstairs. Maybe you left it at the table. We could go back up and have a look around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For someone who hadn’t wanted to leave a minute ago, she didn’t sound enthusiastic at the prospect of going back upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t lose it upstairs,” he said tersely. Well, he had, but not in the way she meant. No wonder the little imp had been looking around so frantically. He wondered how many other men in the ballroom were going to find their faces red this evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you going to call security?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he said absently. “I know exactly what happened to it.” And he was generally such an excellent judge of character. “Would you mind tipping the man for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick was more annoyed than embarrassed to admit that he’d been suckered. He should have known better, of course, but she was a pro—and not the sort he’d thought. Well, hadn’t she told him she wasn’t what he’d thought?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The irony wasn’t lost on him. Roderick thought about calling the police, but he knew he wouldn’t and not just because he’d look foolish. He preferred to deal with the little pickpocket himself. Someone else might report her, of course, but it was a chance he was willing to take. She didn’t know it, but she’d handed him the perfect excuse to find her. And he would. She’d made it easy by taking a taxi. Taxi’s kept records.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re in a perfectly foul mood this evening, you know that?” Shereen asked as he pulled carefully out into traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose I am.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Wisely, she fell silent, leaving him to concentrate on the ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("road. His thoughts were busy conjuring up mock conversations with the imp when he located her. His imagination was enjoying the exercise when Shereen turned toward him again.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am sorry, darling,” she offered, laying a long-fingered hand on his thigh. “I didn’t appreciate how severe your headache must be. I guess you had a beastly night. I’ll make it up to you when we get to my place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Save it, Shereen. You made your point earlier. Consider it taken. Right now I need to concentrate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stiffened and withdrew. He could feel her amber eyes studying him in the glow of the dash lights, but he kept his focus on the road. The windshield wipers struggled to keep up with the falling snow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They drove in tense silence until they reached her apartment complex. Instead of pulling into the parking garage as usual, he drove to the front of the building and stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Darling, I realize you’re annoyed with me and I’m sorry. I wasn’t really flirting with your archenemy, you know. Why don’t you come in and let me make it up to you? It’s far too treacherous to drive all the way into Virginia tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her hand moved to his thigh and stroked upward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Goodbye, Shereen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hand stopped moving and she frowned. “Pouting is most unbecoming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So is using sex to get your own way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She recoiled instantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Happy New Year,” he added sarcastically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The flash of anger in her expression came and went so fast he barely had time to notice. She laid a placating hand on his sleeve, her frown of concern so patently phony he had to force his arm to be still.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll talk in the morning when you’re feeling better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t plan on it, Shereen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes widened as she studied his features. “You’re dumping me? You are! Why you arrogant bastard!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without another word, she exited the car. The slamming of the door shook loose a clump of snow from the roof. Manfully, the wipers struggled to cope as it cascaded over the windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick pulled away without a backward glance. He generally used more finesse when breaking off relationships, but he suspected subtlety would have been wasted on Shereen. He also suspected at least some of her anger was more for show than anything else. If he wasn’t mistaken, Shereen had already selected his replacement. Wilhelm’s pockets better be as deep as reported if he was planning to be the next in line to woo the beautiful model. Shereen didn’t come cheap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The snowplows and salt trucks were operating with almost negligible results. The drive to her apartment had taken longer than it did in rush hour, and what was normally a fifteen-to twenty-minute trip to his place took nearly two nerve-wrenching hours as the weather continued to worsen. His headache was truly wicked by the time he pulled into his garage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick used the spare house key concealed there to let himself into the town house. As he switched the security panel back on for the night, he gave himself a mental reminder to change the code and have the door locks re-keyed. Shereen had both and could let herself in at any time. Fortunately, he didn’t have to worry about that tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("His headache was reaching migraine proportions by the time he kicked off his dress shoes and crossed to the stairs. ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("He was tired. All he wanted was a hot shower and a soft bed.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had nearly reached the upstairs hall when a sudden prickle traveled up his back to lodge at the base of his skull. Roderick stopped moving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no sound out of place. No trace of smoke. The only thing he smelled was the lingering scent of nail polish remover and the bath salts Shereen favored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet something was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrenaline replaced his headache and exhaustion. At thirty-two, he knew better than to ignore his instincts. He backed down the steps quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One touch of the button on the control panel would bring the police and a security team, but he’d feel worse than a fool if he brought anyone out on a night like this and the house was empty. His security system was state-of-the-art technology. By checking the panel he could see at a glance if the system had been breached. It should have alerted him if that had been the case, even if his sister had stopped by for some reason, but it hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was it possible that he was suddenly developing an imagination?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not hardly. The thief had taken his house keys along with his identification. No doubt that had raised subconscious alarms. She couldn’t use the keys to get inside without tripping the alarm, yet the sense of wrongness persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick made his way to the softly glowing panel and ran a diagnostic check. The system recorded no entry prior to his, but it did show a momentary interrupt in power a couple of hours ago. A power surge or a flicker in the house current? It hadn’t lasted long enough to trip his pager and alert him, yet his unease remained.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only sound inside the house was the ticking of the huge grandfather clock in the living room. He checked the doors and windows. All secure. His senses weren’t placated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick abhorred guns, and a knife wasn’t a particularly efficient form of defense against an unknown assailant, but he wanted something in his hand before he went upstairs again. Moving to the kitchen, he crossed the tiles in his stocking feet and quietly removed a heavy skillet. Hefting it, he tested its weight. He was tired and irritable and feeling oddly theatric, but this was his home. If someone had gotten past the system somehow, they were going to regret the action.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He strode to the staircase and promptly stumbled over the shoes he’d left at the bottom. He kept himself from falling, but he’d just lost the element of surprise if someone else was inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jaw set, pan swinging, Roderick mounted the steps by twos. At the top he hit the wall switch. A stream of slightly yellow illumination cast shadows on the walls. Nothing else moved. There was no sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned toward the master bedroom. The double doors yawned wide-open the way he’d left them, yet he entered cautiously. At first glance nothing appeared disturbed. He moved toward the closet and froze. Heart-pounding adrenaline shot through his system. If he hadn’t taken off his shoes downstairs he would never have felt the dampness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someone had walked across the carpeting with wet feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gripped the pan firmly while his heart tried to drill through his chest. His palms slicked with sweat. He gazed about slowly. The bedroom was empty. So was the spacious walk-in closet.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He crossed to the master bath. The large room was a hedonistic delight. The tub sprawled on a raised dais, twice as wide and half again as long and deep as a normal tub. Jets were built into the sides so it could be operated as a whirlpool. A sinfully appealing skylight loomed overhead and there was a separate, oversized shower with multiple heads so that water could run freely over a person from both sides—or two people could share as he and Shereen had done on more than one occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An enormous double vanity filled the far wall with mirrored glass. The glass was partially fogged. His blurred image stared back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Running a quick finger over the inside of the tub he discovered it had been wiped but was still damp. The unmistakable scent of Shereen’s favorite bath oil mingled in the air along with the odor of nail polish remover. That was what his subconscious had tried to alert him to when he started up the stairs. Those odors shouldn’t have been there. Shereen hadn’t used the large bathroom in more than a week.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He strode back to the bedroom. This time when he surveyed the room, he did so slowly, taking in small details. His muscles contracted the moment he spotted his wallet and key case on the tall dresser. Roderick didn’t need to open the expensive leather. It seemed inevitable that his money would all be inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lowered the pan. Red-stained tissues were clumped in his wastebasket. Ridiculously, he was glad. The nail color had been all wrong on her. But how had the little thief gotten past his unbeatable security system?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His legs carried him to the large guest room. He slapped the wall switch. Nothing happened. The lamp on the nightstand must have been turned off at the base. It didn’t matter. The light from the hall was adequate.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first thing he saw was the sparkly green material lying in a heap on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The second thing he saw was the body on the bed.")])])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page46"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1f3859c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459232556_ch02.vue
// module id = 84
// module chunks = 0